import { useEffect } from "react";
import "./StudentHomeScreen.css";
import AchievementsPanel from "./AchievementsPanel";
import AssignmentListPanel from "./AssignmentListPanel";
import { connect } from "react-redux";
import StudentHeader from "../../StudentHeader/StudentHeader";
import { RootState } from "../../../state/configureStore";
import { Redirect, Route } from "react-router-dom";
import Loading from "../../Loading/Loading";
import InformationModal from "../../Modals/InformationModal";
import { closeInformationModal } from "../../Modals/InformationModalReducer";
import AnalyticsService from "../../../services/analytics/AnalyticsService";
import { JoinClassHook } from "../../JoinClass/JoinClassHook";

type StudentHomeScreenProps = ReturnType<typeof mapStateToProps>;
function StudentHomeScreen(props: StudentHomeScreenProps) {
  // Log the screen view
  useEffect(() => {
    AnalyticsService.logScreenView();
  }, []);

  if (props.isConnectingUser || props.isConnectingSettings) {
    return <Loading />;
  }

  // Ensure the user is logged in
  if (!props.profile) {
    return <Route component={() => <Redirect to={{ pathname: "/Login" }} />} render={undefined} />;
  }

  return (
    <div className="fullContainer">
      <JoinClassHook />
      <StudentHeader />
      <div className="StudentHomeScreen" style={{ flex: 1 }}>
        <AchievementsPanel />
        <AssignmentListPanel />
      </div>
      <InformationModal
        title={props.informationModalState.title}
        onOk={closeInformationModal}
        open={props.informationModalState.isOpen}
      >
        {props.informationModalState.message}
      </InformationModal>
    </div>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    profile: state.currentUserState.currentUser,
    isConnectingUser: state.currentUserState.isConnectingUser,
    isLoggedIn: state.currentUserState.currentUser !== undefined,
    isConnectingSettings: state.currentUserState.isConnectingSettings,
    userSettings: state.currentUserState.currentUserSettings,
    informationModalState: state.informationModalState,
  };
};

export default connect(mapStateToProps)(StudentHomeScreen);
